module.exports = __webpack_public_path__ + "static/media/banner-dynasties.f6b0187c.png";